import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'arraySubAreaCardAdd',
    position: [ButtonPosition.arraySubAreaCardOperate],
    action: () => { },
};
